// ignore-string-externalization

import React from 'react';
import { NextPage, NextPageContext } from 'next';
import { Template, TemplateType } from '../../features/Template';
import { NotFound } from '../../features/Layout';
import { getHomePageData } from '../../features/Help/getHelpData';
import { HelpHomeTemplateType } from '../../features/Template/Help/HelpHomeTemplate';

export const HelpHomePage: NextPage<{
  template?: HelpHomeTemplateType | null;
  preview?: boolean;
}> = ({ template, preview }) => {
  if (!template) {
    return <NotFound />;
  }

  return <Template {...(template as TemplateType)} preview={preview} />;
};

HelpHomePage.getInitialProps = async ({
  smartlingLanguage,
  preview = false,
}: NextPageContext & { preview?: boolean; smartlingLanguage: string }) => {
  return await getHomePageData(preview, smartlingLanguage);
};

export default HelpHomePage;
